import MixpanelModule from '@rodeo-dev/diamond-alpaca/dist/mixpanel-module'
import { isSyntheticTestAccount, isE2ETestAccount } from '../../../shared/util/test-utils/checkTestAccount.js'
import app from '../../app.jsx'
import { getIsProductionDomain, isReviewApp } from '../../../shared/util/environment'
const config = require('../../../config/default.json')

// Hold instance of the MixpanelModule as a singleton
export let mixpanelInstance = null

export const mixpanelNoOpInstance = {
  track: () => {},
  reset: () => {}
}

const analyticsSingleton = {
  /**
   * @description It returns the Mixpanel instance which allows to track events.
   * @param {{ team?: object, user?: object, activeUserTeam?: object }} config - by default {team, user, activeUserTeam} will get set,
   * so it's not needed to provide them.
   * @returns MixpanelInstance
   */
  getMixpanelInstance: (
    { team, user, activeUserTeam } = {
      team: app.getTeam(),
      user: app.getUser(),
      activeUserTeam: app.loggedInUserTeam
    }
  ) => {
    const isSyntheticAccount = isSyntheticTestAccount(
      team?.name,
      team?.profile?.email
    )

    const isE2EAccount = isE2ETestAccount(activeUserTeam?.email)

    if (app.isDemo || isReviewApp() || app.isSupportUser() || isSyntheticAccount || isE2EAccount || !team) {
      return mixpanelNoOpInstance // to avoid having errors with synthetic accounts or when the user is not logged in
    }

    if (!mixpanelInstance) {
      analyticsSingleton.setMixpanelInstance(
        new MixpanelModule({
          /**
           * TODO: Gitlab env vars are being applied only on the 'deploy-staging' and 'deploy-live' steps.
           * that means that the mixpanel token can't be read right now in the 'build-web' step. Once that
           * the pipeline is refactored, then MIXPANEL_TOKEN could be used.
           * */
          token: getIsProductionDomain() ? config.mixpanel.token : config.mixpanel.devToken,
          team,
          user,
          activeUserTeam
        })
      )
    }
    return mixpanelInstance
  },
  setMixpanelInstance: instance => {
    mixpanelInstance = instance
  }
}

export default analyticsSingleton
